<!-- @file 桌面端签到组件 -->

<template>
  <div class="plv-check-in-default plv-check-in-default__PC">
    <check-in-list
      class="plv-check-in-list__PC"
      v-if="isShowList"
      :list="list"
    />
    <template v-else>
      <template v-if="isShowResult">
        <div class="plv-iar-check-in-default__success-bg">
          <img src="./imgs/check-in-success-bg.png" alt="" />
          <span>{{ iarTrans('checkIn.checkInSuccess')}}</span>
          <div class="plv-check-in-default__btn__wrap">
            <iar-button v-if="oldCheckInSocket"
                        class="plv-check-in-default__btn--record"
                        type="cancel"
                        @click="$emit('to-hide')">{{ iarTrans('checkIn.close') }}</iar-button>
            <iar-button v-else
                        class="plv-check-in-default__btn--record"
                        type="cancel"
                        @click="getCheckInInfo">{{ iarTrans('checkIn.record') }}</iar-button>
          </div>
        </div>
      </template>
      <template v-else>
        <div class="plv-check-in-default__content">
          <div class="plv-check-in-default__downcount pws-vclass-check-in-default__downcount">
            <span>{{ leftTime || '' }}</span><span>{{ iarTrans('checkIn.second') }}</span>
          </div>
          <p class="plv-check-in-default__content-message">{{ message }}</p>
        </div>
        <div class="plv-check-in-default__btn__wrap">
          <iar-button :disabled="disabled" @click="signIn">{{ iarTrans('checkIn.checkInBtn') }}</iar-button>
        </div>
      </template>
    </template>
  </div>
</template>

<script>
import IarButton from '../../components/common/button/PcButton';
import CheckInList from '../../components/check-in/check-in-list/checkInList';
import mixin from './mixin';

export default {
  components: {
    IarButton,
    CheckInList
  },
  mixins: [mixin],
};
</script>

<style lang="scss">
@font-face {
  font-family: DIN-Bold;
  src: url(./font/DINPro-Bold.otf);
}
.plv-check-in-default__content {
  padding-top: 69px;
  text-align: center;

  .plv-check-in-default__content-message {
    max-width: 350px;
    margin: 20px auto 68px;
    text-align: center;
    line-height: normal;
    word-break: break-all;
  }

  .plv-check-in-default__downcount {
    width: 120px;
    height: 120px;
    margin: 0 auto;
    border-radius: 50%;
    background: rgba(229, 242, 254, 1);
    line-height: 120px;
    font-family: DIN-Bold;

    >span {
      font-size: 14px;
      color: #2196F3;
    }

    >span:nth-child(1) {
      font-size: 32px;
    }

    >span:nth-child(2) {
      margin: 10px 0 0 4px;
    }
  }

  >p {
    color: #606266;
    font-size: 14px;
    margin-top: 20px;
    margin-bottom: 68px;
  }
}
.plv-check-in-default__PC {
  .plv-check-in-list__PC {
    height: 352px;
  }
  .plv-check-in-default__btn__wrap {
    padding-bottom: 24px;
    text-align: center;
  }
  .plv-iar-check-in-default__success-bg {
    padding-top: 61px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    img {
      width: 120px;
      height: 120px;
      margin-bottom: 20px;
    }
  }
  .plv-check-in-default__btn--record {
    border: 1px solid #2196F3;
    color: #2196F3;
    margin-right: 0;
    margin-top: 73px;
    &:hover {
      color: white;
    }
  }
  .plv-check-in-default__btn--record:hover {
    color: white;
  }
}
</style>
